import { render, staticRenderFns } from "./DealsClosesKPI.vue?vue&type=template&id=a58e32a2&"
import script from "./DealsClosesKPI.vue?vue&type=script&lang=js&"
export * from "./DealsClosesKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports